import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { forkJoin, of, Observable, Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CityService } from '../../services/city.service';
import { ContactMultiselectDialog } from '../contact/contact-email-popup.component';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { EmailService } from '../../services/email.service';
import { EmployeeService } from '../../services/employees.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { TMWService } from '../../services/tmw.service';
import { UtilService } from '../../services/util.service';
import {
    APIResponse
    , Carrier
    , CarrierLane
    , CarrierService
    , CarrierServiceMap
    //, City
    , Email
    , Employee
    , MacropointData
    , MacropointGoodTruck
    , MacropointLocationProvider
    , MacropointOrder
    , MacropointTrackingOption
    , Offer
    , OrderEventSchedule
    , OrderEventType
    , PayDetail
    , PayDetailFromAwardOffer
    , QuoteOrderLine
    , QuoteOrderLineCarrierServiceMap
    , SearchCarrierContact
    , SearchCityState
    , SearchOffer
    , SearchOrderEventType
    , SearchOrderStop
    , SearchQuoteOrderLine
    , SearchQuoteOrderLineCarrierService
    , TravelEstimate
} from '../../models/models';

@Component({
    selector: 'carrier-offer-form',
    templateUrl: './carrier-offer-form.component.html',
    standalone: false
})
export class CarrierOfferForm implements OnDestroy, OnInit, OnChanges {
    @Input() viewType: string = "";
    @Input() pageType: string = "";
    @Input() offerID: number = 0;
    @Input() offerBatchID: number = 0;
    @Output() onSaveClick = new EventEmitter<any>();
    @Output() onCancelClick = new EventEmitter<any>();

    private subQuoteOrderLine: Subscription | undefined;

    public isSaving: boolean = false;
    public isPPCChanged: boolean = false;
    private isPPCCompleted: boolean = false;
    public isAutoComplete: boolean = false;
    public isExportHub: boolean = false;
    public isValidExternalTrackingLink: boolean = true;
    // Save status:
    //  0 = no status
    //  1 = saving
    //  2 = fail
    //  3 = success
    public saveStatusOffer: number = 0;
    public saveStatusDeleteSched: number = 0;
    public saveStatusSetSched: number = 0;
    public saveStatusPPC: number = 0;
    public saveStatusSched: number = 0;
    public saveStatusAwardCarrier: number = 0;
    public saveStatusTMW: number = 0;
    public saveStatusPayDetail: number = 0;
    public saveStatusTMWMove: number = 0;
    public saveStatusMacropoint: number = 0;
    public saveStatusAutoComplete: number = 0;

    public isCSRManager: boolean = false;
    public isValid: boolean = true;
    public isExcludeNonRMISCertified: boolean = true;
    public isPayDetailExpanded: boolean = false;
    public payDetailRefreshDate: Date = new Date();
    public validationWarningList: string[] = [];
    private isPickupHoursConfirmed: boolean = false;
    private isTransitHoursConfirmed: boolean = false;
    public offer: Offer = {} as Offer;
    public offerList: Offer[] = [];
    private searchOffer: SearchOffer = {} as SearchOffer;
    private searchOfferList: SearchOffer[] = [];
    public batchOffers: Offer[] = [];
    public carrierLane: CarrierLane = {} as CarrierLane;
    public carrier: Carrier = {} as Carrier;
    //public tender: TenderData = {} as TenderData;
    public payDetail: PayDetail = {} as PayDetail;
    public geocodeLaneID: number = 0;
    public carrierContacts: SearchCarrierContact[] = [];
    public contacts: SearchCarrierContact[] = [];
    public drivers: SearchCarrierContact[] = [];
    public orderStops: SearchOrderStop[] = [];
    public batchOrderStops: SearchOrderStop[] = [];
    private orderEventTypes: OrderEventType[] = [];
    public searchOrderEventTypes: SearchOrderEventType[] = [];
    private schedule: OrderEventSchedule[] = [];
    public carrierReps: Employee[] = [];
    public carrierSalesManagers: Employee[] = [];
    public accountManagers: Employee[] = [];
    public carrierServiceList: CarrierService[] = [];
    public searchLoadCarrierServiceList: SearchQuoteOrderLineCarrierService[] = [];
    public loadServiceMapList: QuoteOrderLineCarrierServiceMap[] = [];
    public loadServiceMap: QuoteOrderLineCarrierServiceMap = {} as QuoteOrderLineCarrierServiceMap;
    public carrierServiceMapList: CarrierServiceMap[] = [];
    public isServiceOverride: boolean = false;
    public macropointGoodTruckList: MacropointGoodTruck[] = [];
    private macropointOrder: MacropointOrder = {} as MacropointOrder;
    public goodTruckEquipmentID: string = "";
    public macropointLocationProviders: MacropointLocationProvider[] = [];
    public macropointTrackingOptionsAll: MacropointTrackingOption[] = [];
    public macropointTrackingOptions: MacropointTrackingOption[] = [];
    public searchQuoteOrderLine: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    //public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public pickupStop: SearchOrderStop = {} as SearchOrderStop;
    public dropStop: SearchOrderStop = {} as SearchOrderStop;
    public selectedContact: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver2: SearchCarrierContact = {} as SearchCarrierContact;
    public macropointData: MacropointData = {} as MacropointData;
    public selectedCarrierRep: Employee = {} as Employee;
    public accessorialCostNotes: string = "";
    private payDetailOffer: PayDetailFromAwardOffer = {} as PayDetailFromAwardOffer;
    public isShowAll: boolean = false;
    //public offers: Observable<Offer[]> = new Observable<Offer[]>();
    public loadStatus: string = "";
    public pickupCity: SearchCityState = {} as SearchCityState;
    public cityStateZipList: SearchCityState[] = [];
    private travelEstimate: TravelEstimate = {} as TravelEstimate;
    public countryCode: string = "US";
    public phoneMask: string = "(999) 000-0000";
    public ppcCity: SearchCityState = {} as SearchCityState;
    public ppcDate: Date = new Date();
    public ppcDateUTC: Date = new Date();
    public isBatchPPCTimeSame: boolean = true;
    public ppcHoursBefore: number = 0;
    public ppcMilesText: string = "";
    public ppcTravelText: string = "";
    public defaultPPCCity: string = "";
    public ppcNotes: string = "";
    public firstPickupEarliestDate: Date = new Date();
    private minFirstPickupEarliestDate: Date = new Date();
    public firstPickupLatestDate: Date = new Date();
    public beginTrackingDate: Date = new Date();
    public endTrackingDate: Date = new Date();
    public isAddDispatcher: boolean = false;
    public isAddDriver1: boolean = false;
    public isAddDriver2: boolean = false;
    public isEditDispatcher: boolean = false;
    public isEditDriver1: boolean = false;
    public isEditDriver2: boolean = false;
    public macropointTrackInterval: number = 0;
    public macropointEventUpdates: boolean = true;
    public macropointEmails: string = "";
    public macropointLocationProviderId: number = 0;
    public macropointLocationProviderDevice: string = "";

    public isLocked: boolean = false;
    private recordLockAction: string = "";
    private recordLockSource: string = "Procurement";
    private isMacropoint: boolean = false;
    private isEmail: boolean = false;

    public ppcCityControl = new UntypedFormControl();
    public offerForm: UntypedFormGroup = new UntypedFormGroup({
        ppcCityStateZipCtrl: new UntypedFormControl(''),
        ppcCityControl: new UntypedFormControl('')
    });

    constructor(private applicationControlService: ApplicationControlService, private azureMapsService: AzureMapsService,
        private cityService: CityService, private cseService: CSEService, private contactService: ContactService,
        private emailService: EmailService, private employeeService: EmployeeService, private erpService: ERPService,
        public dialog: MatDialog, private notificationService: NotificationService, private orderService: OrderService,
        private recordLockService: RecordLockService, private tmwService: TMWService,
        private utilService: UtilService, private ngZone: NgZone) {
        //this.offerSubscription = this.cseService.getOffers().subscribe(result => {
        //    if (result) {
        //        this.offerList.push(result);
        //    }
        //    else {
        //        this.offerList = [];

        //    }
        //});

        this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
            var appValue = result[0].appSettingValue;
            if (appValue == "1") {
                this.isExportHub = true;
            }
            else {
                this.isExportHub = false;
            }
        });

        this.applicationControlService.getApplicationControlsByAppName("IsExcludeNonRMISCertified", false).subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                if (appValue == "1") {
                    this.isExcludeNonRMISCertified = true;
                }
                else {
                    this.isExcludeNonRMISCertified = false;
                }
            }
        });
    }

    ngOnInit() {
        if (this.viewType == "orderentry") {
            //this.isAutoComplete = true;
        }
        this.isCSRManager = this.getIsCSRManager();
        //this.initValues();
        //this.getOffer();
        //console.log("carrier-offer-form:ngOnInit", this.viewType, this.offerID);
        this.initRecordLock();
    }

    ngOnChanges() {
        // Start minimum firstPickupEarliestDate to +7 hours for 6hr warning check.
        this.minFirstPickupEarliestDate.setTime(this.minFirstPickupEarliestDate.getTime() + 7 * 60 * 60 * 1000);
        this.initValues();
        this.getOffer();
        this.getOfferBatch();
        //console.log("carrier-offer-form:ngOnChanges", this.viewType, this.offerID);
    }

    ngOnDestroy() {
        this.recordLockService.resetRecordLock();
        this.recordLockService.continueRecordLockObserver.observers.length = 1;
        this.recordLockService.cancelOverrideObserver.observers.length = 1;
        this.recordLockService.timeoutRecordLockObserver.observers.length = 1;
        this.recordLockService.timeoutConfirmObserver.observers.length = 1;
        this.recordLockService.hasRecordLockObserver.observers.length = 1;
        //console.log("ngOnDestroy", this.recordLockService.cancelOverrideObserver, this.recordLockService.continueRecordLockObserver);
    }

    initValues() {
        this.selectedContact = {} as SearchCarrierContact;
        this.selectedDriver = {} as SearchCarrierContact;
        this.selectedDriver2 = {} as SearchCarrierContact;
        this.selectedCarrierRep = {} as Employee;
        this.selectedDriver.cell = "";
        this.selectedDriver2.cell = "";
        //this.tender = {} as TenderData;
        this.payDetail = {} as PayDetail;
        this.isPPCChanged = false;
        this.ppcDateUTC = this.utilService.getDateAsUTC(new Date());
        this.ppcTravelText = "";
        this.ppcMilesText = "";
        this.ppcNotes = "";

        this.orderService.getOrderEventTypes().subscribe(result => {
            this.orderEventTypes = result.resultCollection;
        });

        this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
            this.searchOrderEventTypes = result;
        });

        this.getGetCarrierServices();
    }

    private getIsCSRManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Carrier Sales Manager') > -1) return true;
        }

        return false;
    }

    private getGetCarrierServices() {
        this.cseService.getAllCarrierServices().subscribe(result => {
            this.carrierServiceList = result;
        });
    }

    private getServiceMaps() {
        this.cseService.getSearchQuoteOrderLineCarrierServiceByQuoteOrderLineID(this.offer.quoteOrderLineID).subscribe(result => {
            this.searchLoadCarrierServiceList = result;
            this.validate(false);
        });
        this.cseService.getQuoteOrderLineServiceMapsByQuoteOrderLineID(this.offer.quoteOrderLineID).subscribe(result => {
            this.loadServiceMapList = result;
        });
        this.getCarrierServiceMaps();
    }

    private getCarrierServiceMaps() {
        this.cseService.getServiceMapsByCarrierId(this.searchOffer.carrierID).subscribe(result => {
            this.carrierServiceMapList = result;
        });
    }

    public overrideLoadServiceMap(serviceMapID: number) {
        var serviceMap = this.loadServiceMapList.find(t => t.quoteOrderLineCarrierServiceMapID == serviceMapID) as QuoteOrderLineCarrierServiceMap;
        this.isServiceOverride = true;
        this.loadServiceMap = serviceMap;
        this.loadServiceMap.overrideEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
    }

    public saveLoadServiceMap() {
        this.utilService.isLoading = true;
        this.cseService.saveQuoteOrderLineCarrierServiceMap(this.loadServiceMap).subscribe(result => {
            this.utilService.isLoading = false;
            this.isServiceOverride = false;
            this.loadServiceMap = {} as QuoteOrderLineCarrierServiceMap;
            this.getServiceMaps();
            //console.log("saveLoadServiceMap", this.loadServiceMap, result);
        });
    }

    private getOffer() {
        if (this.offerID > 0) {
            this.utilService.isLoading = true;
            this.cseService.getOfferByID(this.offerID).subscribe(result => {
                this.offer = result.resultCollection[0];

                this.cseService.getSearchOfferByID(this.offerID).subscribe(result2 => {
                    this.utilService.isLoading = false;
                    this.searchOffer = result2.resultCollection[0];

                    this.continueAwardOffer();
                });
                //console.log("getOffer", this.offer);
            });
        }
    }

    private continueAwardOffer() {
        if (this.offer.awarded == true) {
            this.notificationService.showWarning("This offer is already awarded. Only limited editing is allowed fields.", "WARNING: Offer Awarded");
            //this.cancelOffer();
        }
        else {
            //var ppcCity = this.offerForm.controls['ppcCityControl'].value as City;
        }
        this.getContacts();
        this.getCarrierReps();
        this.getCarrierSalesManagers();
        this.getAccountManagers();
        this.cseService.getCarrierLaneByID(this.offer.carrierLaneID).subscribe(result => {
            this.carrierLane = result.resultCollection[0];
            this.cseService.getCarrierByID(this.carrierLane.carrierID).subscribe(result2 => {
                this.carrier = result2.resultCollection[0];
                this.setOfferData();
            });
        });
        this.getServiceMaps();
        this.setPayDetail();
        //this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(this.offer.quoteOrderLineID);
        this.getQuoteOrderLine(this.offer.quoteOrderLineID);
        this.getOrderEventSchedule(this.offer.quoteOrderLineID);
        this.getOrderStops(this.offer.quoteOrderLineID);
                        //console.log("getOffer", this.offerID, this.offer);
    }

    private getOfferBatch() {
        if (this.offerBatchID > 0) {
            this.utilService.isLoading = true;
            this.cseService.getSearchOfferByOfferBatchID(this.offerBatchID).subscribe(result => {
                this.searchOfferList = result.resultCollection;
                this.searchOffer = result.resultCollection[0];
                this.checkRMISCertified();
                this.cseService.getOffersByOfferBatchID(this.offerBatchID).subscribe(result => {
                    this.utilService.isLoading = false;
                    this.batchOffers = result.resultCollection;
                    this.offer = Object.assign({}, this.batchOffers[0]);
                    //console.log("getOffer", this.offer);

                    this.continueAwardOffer();
                });
            });
        }
    }

    private setOfferData() {
        //this.macropointLocationProviderId = this.offer.carrierLane.carrier.macropointLocationProviderId;
        this.macropointLocationProviderId = this.carrier.macropointLocationProviderId;

        //console.log("setOfferData:before", this.offer, this.carrier, this.offer.quoteOrderLine);
        if (this.offer.awarded != true) {
            this.offer.quoteOrderLine.cost = this.offer.offerRate;
            this.offer.quoteOrderLine.carrierID = this.carrier.carrierID;
            this.offer.quoteOrderLine.awardedCarrierRepId = this.offer.createdByEmployeeID;
        }
        //console.log("setOfferData:after", this.offer, this.carrier, this.offer.quoteOrderLine);

        if (this.offer.quoteOrderLine.carrierID == null || this.offer.quoteOrderLine.carrierID == 0) {
            this.isValid = false;
            alert("There is an error in loading the carrier for this load. Cancelling the award process. Please attempt to award again or select the carrier on this load again.");
            this.cancelOffer();
        }

        this.getMacropointLocationProviders();
        //this.getMacropointTrackingOptions();

        this.cityService.getSearchCityStateByCityID(this.carrier.cityID).subscribe(result => {
            var city: SearchCityState = result.resultCollection[0];
            this.countryCode = (city.countryAbbr.trim() == "MX" ? "MX" : "US");
        });

        //this.pickupCity = this.offer.quoteOrderLine.oCity;
        this.cityService.getSearchCityStateByCityID(this.searchOffer.originCityID!).subscribe(result => {
            this.pickupCity = result.resultCollection[0];
        });

        this.offer.updatedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);

        this.setTrackingDates();
    }

    private setTrackingDates() {
        //if (this.offer.quoteOrderLine.originalPickupDate != null) {
        if (this.pickupStop.arrivalDateUTC != null) {
            //var pickupDate: Date = new Date(this.offer.quoteOrderLine.originalPickupDate);
            // Use pickup stop arrival date and convert to UTC
            var isPast: boolean = false;
            var pickupDate: Date = new Date(this.pickupStop.arrivalDateUTC);
            var nowDate: Date = this.utilService.getLocalDateInUTC(new Date());
            // Check if date is in past and add 5min to "now" if so
            if (nowDate > pickupDate) {
                isPast = true;
                pickupDate = this.utilService.addMinutes(nowDate, 5);
            }

            pickupDate = new Date(this.utilService.getUTCDateAsLocalDate(pickupDate));

            //this.ppcDate = pickupDate;
            ////firstPickup.ArrivalDate.Value.AddHours(-1);
            //this.ppcDate.setTime(pickupDate.getTime() - 60 * 60 * 1000);
            //this.firstPickupEarliestDate = pickupDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
            //firstPickup.ArrivalDate.Value.AddHours(-3);
            this.beginTrackingDate = pickupDate;
            if (!isPast) {
                this.beginTrackingDate.setTime(pickupDate.getTime() - 3 * 60 * 60 * 1000);
            }
        }
        if (this.searchQuoteOrderLine.deliveryDate != null) {
            // Use last stop DepartDateUTC instead of line.OriginalDeliveryDate
            //var deliveryDate: Date = new Date(this.offer.quoteOrderLine.originalDeliveryDate);
            //var deliveryDate: Date = new Date(this.dropStop.departDateUTC);
            var deliveryDate: Date = new Date(this.searchQuoteOrderLine.deliveryDate);
            this.endTrackingDate = deliveryDate;
            this.endTrackingDate.setTime(deliveryDate.getTime() + 8 * 60 * 60 * 1000);
        }
    }

    public isCarrierServiceMap(carrierServiceID: number) {
        var serviceMap = this.carrierServiceMapList.find(t => t.carrierServiceID == carrierServiceID);
        if (serviceMap == null) {
            return false;
        }
        else {
            return true;
        }
    }

    public isLoadCarrierServiceComplete() {
        var serviceMaps = this.searchLoadCarrierServiceList.filter(t => t.carrierServiceMapID == null && t.overrideManagerEmployeeID == null);
        var isValid: boolean = true;
        for (var i = 0; i < this.searchLoadCarrierServiceList.length; i++) {
            var serviceMap = this.searchLoadCarrierServiceList[i];
            if (!this.isCarrierServiceMap(serviceMap.carrierServiceID) && serviceMap.overrideManagerEmployeeID == null) {
                isValid = false;
            }
        }
        return isValid;
    }

    private setPayDetail() {
        this.payDetail.unit = "FLT";
        this.payDetail.quantity = 1;
    }

    public togglePayDetail() {
        this.isPayDetailExpanded = !this.isPayDetailExpanded;
        this.payDetailRefreshDate = new Date();
    }

    private getContacts() {
        this.utilService.isLoading = true;
        this.contactService.getSearchContactByCarrierID(this.searchOffer.carrierID).subscribe(result => {
            this.carrierContacts = result.resultCollection;
            this.contacts = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() != "driver");
            this.drivers = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() == "driver");
            this.initContacts();
            this.utilService.isLoading = false;
            //console.log("getContacts", this.contacts, this.drivers);
        });
    }

    private getQuoteOrderLine(quoteOrderLineID: number) {
        //var name = "getSearchQuoteOrderLineByQuoteOrderLineID-" + quoteOrderLineID;
        //if (this.subQuoteOrderLine) {
        //    this.subQuoteOrderLine.unsubscribe();
        //}
        //var data = this.dataService.get(name);
        //if (data) {
        //    this.searchQuoteOrderLine = data.resultCollection[0];
        //    this.loadStatus = this.searchQuoteOrderLine.loadStatus;

        //    //this.initContacts();
        //    //this.setupQuoteOrderLines(data.resultCollection);
        //    //console.log("offerList", this.offerList);
        //}
        //else {
        //    this.utilService.isLoading = true;
        //    this.subQuoteOrderLine = this.dataService.currentDataCollection.subscribe(result => {
        //        this.utilService.isLoading = false;
        //        if (result.name == name) {
        //            this.searchQuoteOrderLine = result.resultCollection[0];
        //            this.loadStatus = this.searchQuoteOrderLine.loadStatus;

        //            //this.initContacts();
        //            //this.setupQuoteOrderLines(result.resultCollection);
        //            //console.log("offerList", this.offerList);
        //        }
        //    });
        //}

        this.orderService.getSearchQuoteOrderLineByID(quoteOrderLineID).subscribe(result => {
            this.searchQuoteOrderLine = result.resultCollection[0];
            this.loadStatus = this.searchQuoteOrderLine.loadStatus;
            if (this.searchQuoteOrderLine.deliveryDate != null) {
                // Use last stop DepartDateUTC instead of line.OriginalDeliveryDate
                //var deliveryDate: Date = new Date(this.offer.quoteOrderLine.originalDeliveryDate);
                //var deliveryDate: Date = new Date(this.dropStop.departDateUTC);
                var deliveryDate: Date = new Date(this.searchQuoteOrderLine.deliveryDate);
                this.endTrackingDate = deliveryDate;
                this.endTrackingDate.setTime(deliveryDate.getTime() + 8 * 60 * 60 * 1000);
            }
            this.handleRecordLock(this.searchQuoteOrderLine.quoteOrderID);
        });

    //    this.orderService.getQuoteOrderLineById(quoteOrderLineID).subscribe(result => {
    //        this.quoteOrderLine = result;
    //        this.initContacts();
    //    })
    }

    private checkRMISCertified() {
        // Check if SearchQuoteOrderLine and SearchOffer are loaded
        var isRMISCertified: boolean = true;
        var isMexicoOnly: boolean = true;
        var isExcludeRMISCertification: boolean = false;
        for (var i = 0; i < this.searchOfferList.length; i++) {
            if (this.searchOfferList[i].isMexicoOnly != true) {
                isMexicoOnly = false;
            }
            if (this.searchOfferList[i].isExcludeRMISCertification == true) {
                isExcludeRMISCertification = true;
            }
            if (this.searchOfferList[i].isRMISCertified != true) {
                isRMISCertified = false;
            }
        }
        if (this.isExcludeNonRMISCertified && !isRMISCertified && !isMexicoOnly && !isExcludeRMISCertification) {
            // Carrier not RMIS certified and app control flag set
            this.isValid = false;
            //this.notificationService.showWarning("Carrier is not RMIS certified. Award not available.", "WARNING: Not RMIS Certified");
            alert("Carrier is not RMIS certified and batch is not Mexico only. Award not available. Cancelling the award process.");
            this.cancelOffer();
        }
    }

    private getOrderEventSchedule(quoteOrderLineID: number) {
        this.orderService.getOrderEventScheduleByQuoteOrderLineId(quoteOrderLineID).subscribe(result => {
            this.schedule = result.resultCollection;
            this.setDefaultPPCCity();
        });
    }

    private initContacts() {
        if (this.offer.quoteOrderLine.carrierContactId != null) {
            this.selectedContact = this.contacts.find(c => c.contactID == this.offer.quoteOrderLine.carrierContactId)! || {} as SearchCarrierContact;
        }
        if (this.offer.quoteOrderLine.driverId != null) {
            this.selectedDriver = this.drivers.find(c => c.contactID == this.offer.quoteOrderLine.driverId)! || {} as SearchCarrierContact;
        }
        if (this.offer.quoteOrderLine.driver2Id != null) {
            this.selectedDriver2 = this.drivers.find(c => c.contactID == this.offer.quoteOrderLine.driver2Id)! || {} as SearchCarrierContact;
        }
        this.validate(true);
        //console.log("initContacts", this.selectedContact, this.selectedDriver, this.selectedDriver2);
    }

    private getOrderStops(quoteOrderLineID: number) {
        if (this.batchOffers.length > 0) {
            var obsList: Observable<APIResponse>[] = [];
            for (var i = 0; i < this.batchOffers.length; i++) {
                var obs: Observable<APIResponse> = this.orderService.getSearchOrderStopsByQuoteOrderLineID(this.batchOffers[i].quoteOrderLineID);
                obsList.push(obs);
                //console.log("getOrderStops:obsList.push", i, this.batchOffers[i].quoteOrderLineID);
            }
            forkJoin(obsList).subscribe(result => {
                var hours = new Date().getHours();
                var minutes = new Date().getMinutes();
                this.isBatchPPCTimeSame = true;
                //console.log("getOrderStops:result", this.isBatchPPCTimeSame, result);
                for (var i = 0; i < result.length; i++) {
                    var stops: SearchOrderStop[] = result[i].resultCollection;
                    //console.log("getOrderStops:result[" + i + "]:stops", stops);
                    stops = stops.sort((left, right): number => {
                        if (left.stopSequence < right.stopSequence) return -1;
                        if (left.stopSequence > right.stopSequence) return 1;
                        return 0;
                    });
                    var stop = stops.filter(s => s.eventCode == "HLT" || s.eventCode == "LLD");
                    //console.log("getOrderStops:stop", stop);
                    if (stop.length > 0) {
                        var pickupStop = stop[0];
                        var ppcDate = new Date(pickupStop.earliestDate);
                        ppcDate.setTime(ppcDate.getTime() - 2 * 60 * 60 * 1000);
                        if (i == 0) {
                            hours = ppcDate.getHours();
                            minutes = ppcDate.getMinutes();
                            this.pickupStop = stop[0];
                            this.getTravelEstimate();
                            var pickupEarliestDate: Date = new Date(this.pickupStop.earliestDate);
                            var pickupLatestDate: Date = new Date(this.pickupStop.latestDate);
                            this.ppcDate = new Date(this.pickupStop.earliestDate);
                            this.ppcDateUTC = new Date(this.pickupStop.earliestDateUTC);
                            this.ppcDate.setTime(this.ppcDate.getTime() - 2 * 60 * 60 * 1000);
                            this.ppcDateUTC.setTime(this.ppcDateUTC.getTime() - 2 * 60 * 60 * 1000);
                            this.firstPickupEarliestDate = pickupEarliestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
                            this.firstPickupLatestDate = pickupLatestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
                            if (pickupEarliestDate < this.minFirstPickupEarliestDate) {
                                this.minFirstPickupEarliestDate = pickupEarliestDate;
                            }
                        }
                        else if (hours != ppcDate.getHours() || minutes != ppcDate.getMinutes()) {
                            this.isBatchPPCTimeSame = false;
                        }
                        stop = this.orderStops.filter(s => s.eventCode == "DLT" || s.eventCode == "LUL");
                        if (stop.length > 0) {
                            this.dropStop = stop[stop.length - 1];
                        }
                        //console.log("getOrderStops:ppcDate,isBatchPPCTimeSame", ppcDate, this.isBatchPPCTimeSame);
                    }
                    for (var j = 0; j < stops.length; j++) {
                        this.batchOrderStops.push(stops[j]);
                    }
                    //console.log("getOrderStops:hours,minutes,isBatchPPCTimeSame,stop,stops", hours, minutes, this.isBatchPPCTimeSame, stop, stops);
                }

                this.setTrackingDates();
            });
        }
        else {
            this.orderService.getSearchOrderStopsByQuoteOrderLineID(quoteOrderLineID).subscribe(result => {
                this.orderStops = result.resultCollection;
                var stops: SearchOrderStop[] = result.resultCollection;
                stops = stops.sort((left, right): number => {
                    if (left.stopSequence < right.stopSequence) return -1;
                    if (left.stopSequence > right.stopSequence) return 1;
                    return 0;
                });
                var stop = this.orderStops.filter(s => s.eventCode == "HLT" || s.eventCode == "LLD");
                if (stop.length > 0) {
                    this.pickupStop = stop[0];
                    this.getTravelEstimate();
                    var pickupEarliestDate: Date = new Date(this.pickupStop.earliestDate);
                    var pickupLatestDate: Date = new Date(this.pickupStop.latestDate);
                    this.ppcDate = new Date(this.pickupStop.earliestDate);
                    this.ppcDateUTC = new Date(this.pickupStop.earliestDateUTC);
                    this.ppcDate.setTime(this.ppcDate.getTime() - 2 * 60 * 60 * 1000);
                    this.ppcDateUTC.setTime(this.ppcDateUTC.getTime() - 2 * 60 * 60 * 1000);
                    this.firstPickupEarliestDate = pickupEarliestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
                    this.firstPickupLatestDate = pickupLatestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
                    if (pickupEarliestDate < this.minFirstPickupEarliestDate) {
                        this.minFirstPickupEarliestDate = pickupEarliestDate;
                    }
                }
                stop = this.orderStops.filter(s => s.eventCode == "DLT" || s.eventCode == "LUL");
                if (stop.length > 0) {
                    this.dropStop = stop[stop.length - 1];
                }

                this.setTrackingDates();

                this.validate(true);
            });
        }
    }

    private getPickupHours() {
        //var startDate: Date = new Date(this.firstPickupEarliestDate);
        var startDate: Date = new Date(this.minFirstPickupEarliestDate);
        var endDate: Date = new Date();
        var hoursDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (60 * 60 * 1000);
        return hoursDiff;
    }

    private getTransitHours() {
        var hoursDiff = 0;
        if (this.orderStops.length > 0) {
            var startDate: Date = new Date(this.orderStops[0].arrivalDate);
            var endDate: Date = new Date(this.orderStops[this.orderStops.length - 1].arrivalDate);
            var hoursDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (60 * 60 * 1000);
        }
        return hoursDiff;
    }

    private getCarrierReps() {
        this.employeeService.getEmployeesByGroupName('CarrierRep').subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < emps.length; i++) {
                emps[i].winUserName = (emps[i].winUserName == null ? "" : emps[i].winUserName.toUpperCase());
            }
            this.carrierReps = emps;
        });
    }

    private getCarrierSalesManagers() {
        this.employeeService.getEmployeesByGroupName('Carrier Sales Managers').subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < emps.length; i++) {
                emps[i].winUserName = (emps[i].winUserName == null ? "" : emps[i].winUserName.toUpperCase());
            }
            this.carrierSalesManagers = emps;
        });
    }

    private getAccountManagers() {
        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < emps.length; i++) {
                emps[i].winUserName = (emps[i].winUserName == null ? "" : emps[i].winUserName.toUpperCase());
            }
            this.accountManagers = emps;
        });
    }

    private setMacropointOrderData() {
        // Editing awarded offer, so get MacropointOrder if it exists
        if (this.offer.quoteOrderLine.macropointOrderId > 0) {
            this.orderService.getMacropointOrderByID(this.offer.quoteOrderLine.macropointOrderId).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.macropointOrder = result.resultCollection[0];
                    // Override carrier default with actual order
                    this.macropointLocationProviderId = this.macropointOrder.macropointLocationProviderId;
                    this.macropointLocationProviderChange(this.macropointLocationProviderId);
                    var truckNumber = this.offer.quoteOrderLine.truckNumber;
                    if (truckNumber != null && truckNumber != "" && this.macropointLocationProviders.length > 0) {
                        if (this.macropointGoodTruckList.length > 0) {
                            var goodTruck = this.macropointGoodTruckList.find(t => t.equipmentID == truckNumber);
                            if (goodTruck == null) {
                                this.goodTruckEquipmentID = "- Other -";
                            }
                            else {
                                this.goodTruckEquipmentID = goodTruck.equipmentID;
                            }
                        }
                    }
                }
            });
        }
    }

    private getMacropointGoodTrucks(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.orderService.getMacropointGoodTrucksByCarrierID(this.searchOffer.carrierID, isRefresh).subscribe(result => {
            this.utilService.isLoading = false;
            this.macropointGoodTruckList = result.resultCollection;
        });
    }

    public macropointGoodTruckChange(evt: any) {
        if (evt != null) {
            var truckNumber: string = evt.target.value;
            if (truckNumber != '- Other -') {
                this.offer.quoteOrderLine.truckNumber = evt.target.value;
            }
            else {
                this.offer.quoteOrderLine.truckNumber = "";
            }
        }
        //console.log("macropointGoodTruckChange", evt);
    }

    private getMacropointLocationProviders() {
        this.orderService.getMacropointLocationProviders().subscribe(result => {
            this.macropointLocationProviders = result;
            this.getMacropointTrackingOptions();
            this.getMacropointGoodTrucks(false);
            if (this.offer.awarded == true) {
                this.setMacropointOrderData();
            }
        });
    }

    private getMacropointTrackingOptions() {
        this.orderService.getMacropointTrackingOptions().subscribe(result => {
            this.macropointTrackingOptionsAll = result;
            //this.macropointTrackingOptions = Object.assign([], this.macropointTrackingOptionsAll);
            var option = result.find(p => p.macropointTrackingOptionID == this.macropointLocationProviderId);
            this.filterMacropointLocationProvider(option!.locationProvider);
            this.macropointLocationProviderChange(this.macropointLocationProviderId);
            //this.getTrackVia();
        });
    }

    public macropointLocationProviderChange(evt: any) {
        //console.log("macropointLocationProviderChange", evt);
        var providerID = 0;
        if (!isNaN(evt) && evt != null && evt > 0) {
            providerID = evt;
        }
        else {
            providerID = evt.target.value;
        }
        var trackVia: MacropointLocationProvider | undefined;
        if (providerID > 0) {
            trackVia = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == providerID);
            if (trackVia != null) {
                this.macropointLocationProviderDevice = trackVia.trackType;
                this.filterMacropointLocationProvider(trackVia!.provider);
            }
        }
        //console.log("macropointLocationProviderChange", this.macropointLocationProviderDevice);
        this.validate(true);
    }

    //private getTrackVia() {
    //    var trackVia: MacropointLocationProvider | undefined;
    //    trackVia = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == this.macropointLocationProviderId);
    //    if (trackVia != null) {
    //        this.macropointLocationProviderDevice = trackVia.trackType;
    //        //this.filterMacropointLocationProvider(trackVia!.provider);
    //        this.macropointLocationProviderChange(this.macropointLocationProviderId);
    //    }
    //    //console.log("getTrackVia", this.macropointLocationProviderDevice);
    //    this.validate(true);
    //}

    private filterMacropointLocationProvider(provider: string) {
        var options: MacropointTrackingOption[] = [];
        if (provider == "") {
            options = Object.assign([], this.macropointTrackingOptionsAll);
        }
        else {
            options = this.macropointTrackingOptionsAll.filter(t => t.locationProvider == provider);
        }
        this.macropointTrackingOptions.length = 0;
        for (var i = 0; i < options.length; i++) {
            if (this.macropointTrackingOptions.findIndex(o => o.locationProvider == options[i].locationProvider && o.trackInterval == options[i].trackInterval && o.trackAmount == options[i].trackAmount) < 0) {
                this.macropointTrackingOptions.push(options[i]);
            }
        }
    }

    public contactChange(evt: any) {
        //console.log("contactChange", evt.target.value, this.offer.quoteOrderLine.carrierContactId);
        var contactID = evt.target.value;
        if (contactID != "") {
            this.selectedContact = this.contacts.find(c => c.contactID == contactID)!;
            this.offer.quoteOrderLine.carrierContactId = contactID;
            //this.offer.quoteOrderLine.carrierContactId = this.selectedContact.contactID;
            //this.tender.carrierContactId = this.selectedContact.contactID;
        }
        else {
            this.selectedContact = {} as SearchCarrierContact;
        }
        if (this.selectedContact.phone == undefined) {
            this.selectedContact.phone = "";
        }
        if (this.selectedContact.email == undefined) {
            this.selectedContact.email = "";
        }
        this.validate(true);
    }

    public addContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isAddDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isAddDriver2 = true;
        }
    }

    public editContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isEditDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isEditDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isEditDriver2 = true;
        }
    }

    public refreshContacts(contactID: number, contactType: string) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = false;
            this.isEditDispatcher = false;
            this.offer.quoteOrderLine.carrierContactId = contactID;
        }
        else if (contactType == "Driver1") {
            this.isAddDriver1 = false;
            this.isEditDriver1 = false;
            this.offer.quoteOrderLine.driverId = contactID;
        }
        else if (contactType == "Driver2") {
            this.isAddDriver2 = false;
            this.isEditDriver2 = false;
            this.offer.quoteOrderLine.driver2Id = contactID;
        }
        //console.log("refreshContacts", contactID, contactType);
        this.getContacts();
    }

    public driverChange(evt: any, num: number) {
        //console.log("driverChange", evt, evt.target.value, num);
        var contactID = evt.target.value;
        if (contactID != "") {
            if (num == 2) {
                this.selectedDriver2 = this.drivers.find(c => c.contactID == contactID)!;
                this.offer.quoteOrderLine.driver2Id = this.selectedDriver2.contactID;
                //this.tender.driverTwoId = this.selectedDriver2.contactID;
                //this.tender.driver2Name = this.selectedDriver2.contactName;
                //this.tender.driver2Cell = this.selectedDriver2.cell;
            }
            else {
                this.selectedDriver = this.drivers.find(c => c.contactID == contactID)!;
                this.offer.quoteOrderLine.driverId = this.selectedDriver.contactID;
                //this.tender.driverOneId = this.selectedDriver.contactID;
                //this.tender.driver1Name = this.selectedDriver.contactName;
                //this.tender.driver1Cell = this.selectedDriver.cell;
            }
        }
        else {
            if (num == 2) {
                this.selectedDriver2 = {} as SearchCarrierContact;
            }
            else {
                this.selectedDriver = {} as SearchCarrierContact;
            }
        }
        if (this.selectedDriver.cell == undefined) {
            this.selectedDriver.cell = "";
        }
        if (this.selectedDriver2.cell == undefined) {
            this.selectedDriver2.cell = "";
        }
        this.validate(true);
    }

    public carrierRepChange(evt: any) {
        //console.log("carrierRepChange", evt);
        var repID = evt.target.value;
        this.selectedCarrierRep = this.carrierReps.find(c => c.employeeId == repID)!;
        //this.tender.carrierRepName = this.selectedCarrierRep.fullName;
        //this.tender.carrierRepPhone = this.selectedCarrierRep.phone
        //this.tender.carrierRepCell = this.selectedCarrierRep.cell;
        //this.tender.carrierRepFax = this.selectedCarrierRep.fax;
    }

    public csManagerEmployeeChange(evt: any) {
        //console.log("csManagerEmployeeChange", evt);
        var mgrID = evt.target.value;
        var emp: Employee = this.carrierSalesManagers.find(c => c.employeeId == mgrID)!;
        //this.offer.csMangerEmployee = emp;
        for (var i = 0; i < this.batchOffers.length; i++) {
            this.batchOffers[i].csManagerEmployeeID = emp.employeeId;
            //this.batchOffers[i].csMangerEmployee = emp;
        }
        this.validate(false);
    }

    public overMaxPayNotesChange(evt: any) {
        //console.log("csManagerEmployeeChange", evt);
        var notes = evt.target.value;
        for (var i = 0; i < this.batchOffers.length; i++) {
            this.batchOffers[i].overMaxPayNotes = notes;
        }
    }

    public ppcDateChanged() {
        this.isPPCChanged = true;
        //this.ppcDateUTC = this.utilService.getTimeZoneDateAsLocalDate(this.ppcDate, this.ppcCity.epiTimeZone.ianaTimeZoneName);
        //this.ppcDateUTC = this.utilService.getLocalDateInUTC(this.ppcDateUTC);
        //var ppcDate = this.utilService.getTimeZoneDateAsLocalDate(this.ppcDate, this.ppcCity.epiTimeZone.ianaTimeZoneName);
        var ppcDate = this.utilService.getTimeZoneDateAsLocalDate(this.ppcDate, this.ppcCity.ianaTimeZoneName);
        var trackingDate = new Date(ppcDate);
        this.beginTrackingDate = trackingDate;
        this.beginTrackingDate.setTime(trackingDate.getTime() - 1 * 60 * 60 * 1000);
        this.updateTravelEstimate();
        this.validate(false);
    }

    public getTotalCost() {
        var total = this.offer.quoteOrderLine.cost + this.offer.quoteOrderLine.fuelCost + this.offer.quoteOrderLine.accessorialCost;
        return parseFloat(total.toFixed(2));
    }

    //public awardOffer(offer: Offer) {
    //    this.cseService.awardOffer(offer).subscribe(result => {
    //        offer = result;
    //    });
    //}

    public ppcCitySTChanged(evt: any, isDefault: boolean) {
        this.ppcTravelText = "";
        this.ppcMilesText = "";
        if (!isDefault && evt != this.ppcCity.cityID) {
            this.isPPCChanged = true;
        }

        var cityID = evt;
        this.utilService.isLoading = true;
        this.cityService.getSearchCityStateByCityID(cityID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.ppcCity = result.resultCollection[0];
                this.checkSameCity();
                //console.log("citySTChanged:customerCity", cityID, this.ppcCity, result);

                this.getTravelEstimate();
                this.validate(false);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private getTravelEstimate() {
        //console.log("getTravelEstimate", this.ppcCity, this.pickupStop);
        if (this.ppcCity.cityID != undefined && this.pickupStop.orderStopID != undefined) {
            var cityID: number = 0;
            if (this.pickupStop.customerCityID > 0) {
                cityID = this.pickupStop.customerCityID;
            }
            else {
                cityID = this.pickupStop.orderStopCityID;
            }

            this.azureMapsService.getTravelEstimate(this.ppcCity.cityID, cityID, this.searchQuoteOrderLine.trailerTypeID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result == null) return;

                this.travelEstimate = result;
                this.updateTravelEstimate();
            });
        }
    }

    //public ppcCitySet(evt: any, isDefault: boolean) {
    //    this.ppcTravelText = "";
    //    this.ppcMilesText = "";
    //    if (!isDefault) {
    //        this.isPPCChanged = true;
    //    }
    //    var ppcCity = this.offerForm.controls['ppcCityControl'].value as City;
    //    this.ppcCity = ppcCity;

    //    if (ppcCity == null) return;

    //    this.checkSameCity();

    //    this.utilService.isLoading = true;
    //    this.azureMapsService.getTravelEstimate(this.ppcCity.cityId, this.pickupStop.city.cityId).subscribe(result => {
    //        this.utilService.isLoading = false;
    //        if (result == null) return;

    //        this.travelEstimate = result;
    //        this.updateTravelEstimate();
    //    });

    //    this.validate(false);
    //    console.log("ppcCitySet", ppcCity, this.ppcCity);
    //}

    private checkSameCity() {
        //console.log("checkSameCity", this.ppcCity, this.pickupCity, this.searchOffer);
        if (this.ppcCity.cityST && this.pickupCity.cityST && this.ppcCity.cityST.toLowerCase() == this.pickupCity.cityST.toLowerCase() && this.ppcCity.cityID != this.pickupCity.cityID) {
            // Same City/ST but different zip
            this.ppcCity = Object.assign({}, this.pickupCity);
            //this.offerForm.controls['ppcCityControl'].setValue(this.ppcCity);
        }
        //console.log("checkSameCity", this.ppcCity, this.pickupCity, this.searchOffer);
    }

    private setDefaultPPCCity() {
        this.isPPCCompleted = false;
        var ppcType = this.orderEventTypes.find(t => t.code == "PPC")!;
        var sched: OrderEventSchedule = this.schedule.find(r => r.orderEventTypeID == ppcType.orderEventTypeID)!;
        //this.defaultPPCCity = this.schedule.find(c => c.orderEventScheduleID == sched.orderEventScheduleId)!.stopCityState;
        if (sched) {
            this.isPPCCompleted = (sched.completed == true ? true : false);
            this.utilService.isLoading = true;
            this.cityService.getSearchCityStateByCityID(sched.cityID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    var city = result.resultCollection[0] as SearchCityState;
                    this.defaultPPCCity = city.cityST;
                    this.ppcCity = city;
                    this.ppcNotes = sched.notes;
                    this.ppcDate = new Date(sched.orderEventDate);
                    this.ppcDateUTC = new Date(sched.orderEventDateUTC == undefined ? sched.orderEventDate : sched.orderEventDateUTC);
                    this.isPPCChanged = false;
                    this.ppcCitySTChanged(city.cityID, true);
                    //this.offerForm.controls['ppcCityControl'].setValue(city);
                    //this.ppcCitySet(sched, true);
                //    console.log("setDefaultPPCCity:getCitiesById", sched.cityId, city);
                }
            });
        }
        //console.log("setDefaultPPCCity", sched);
    }

    private updateTravelEstimate() {
        this.ppcTravelText = "";
        this.ppcMilesText = "";

        if (this.travelEstimate.miles == undefined) return;

        this.ppcMilesText = this.travelEstimate.miles + " miles";

        var ppcCity = this.ppcCity;
        //var ppcCity = this.offerForm.controls['ppcCityControl'].value as City;
        if (ppcCity == null) return;

        //var pickupLatestDate = new Date(this.pickupStop.latestDate);
        var ppcDate = new Date(this.ppcDate);
        var est = (ppcDate && ppcDate != null ? new Date(ppcDate) : new Date());
        var travelTimeHr: number = this.travelEstimate.miles / 50;
        var travelTimeMin: number = travelTimeHr * 60;
        var travelTimeSec: number = travelTimeMin * 60;
        var resultSec = (travelTimeSec + this.travelEstimate.breakHours * 3600);
        var resultMin = resultSec / 60;
        var resultHour = resultMin / 60;
        var travelSpeed = 50;
        var isOverrideTravelTime = true;

        if (isOverrideTravelTime) {
            resultSec = (this.travelEstimate.miles / travelSpeed + this.travelEstimate.breakHours) * 3600;
            resultMin = resultSec / 60;
            resultHour = resultMin / 60;
        }

        est.setSeconds(est.getSeconds() + resultSec);

        var travelHours = Math.floor(resultHour >= 1 ? resultHour : 0);
        var travelMin = Math.round(resultMin - travelHours * 60);
        //console.log("updateTravelEstimate", resultSec, resultMin, resultHour, est, travelHours, travelMin);
        var travelText = "Estimated drive time: ";
        if (travelHours > 0) {
            travelText += travelHours;
            if (travelHours == 1) {
                travelText += " hour ";
            }
            else {
                travelText += " hours ";
            }
        }
        travelText += travelMin + " minutes ";

        var eta = (est.getMonth() + 1) + '/' + est.getDate() + '/' + est.getFullYear() + ' ' + est.getHours() + ':' +
            (est.getMinutes() < 10 ? '0' + est.getMinutes() : est.getMinutes());

        //var comment = ppcCity.cityStateZip + ' ' + this.travelEstimate.miles + ' miles from ' + this.pickupStop.cityStateZip + '.  ' + travelText + ' - ' + eta + ' ETA';
        var comment = ppcCity.cityST + ' ' + ppcCity.zip + ' ' + this.travelEstimate.miles + ' miles from ' + this.pickupStop.cityStateZip + '.  ' + travelText + ' - ' + eta + ' ETA';

        //console.log("updateTravelEstimate", est, this.firstPickupLatestDate);
        if (est >= new Date(this.firstPickupLatestDate)) {
            this.ppcTravelText = comment;
        }
        else {
            this.ppcTravelText = "";
        }
    }

    private validate(isMacropoint: boolean) {
        this.isValid = true;
        this.validationWarningList.length = 0;
        var ppcCity = this.ppcCity;
        //var ppcCity = this.offerForm.controls['ppcCityControl'].value as City;
        if (this.selectedContact.email == null || this.selectedContact.email == "") {
            this.isValid = false;
            this.validationWarningList.push("Contact email required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "Mobile" && (this.selectedDriver.cell == null || this.selectedDriver.cell == "")) {
            this.isValid = false;
            this.validationWarningList.push("Driver Cell required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "VehicleID" && (this.offer.quoteOrderLine.truckNumber == null || this.offer.quoteOrderLine.truckNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Truck # required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "TrailerID" && (this.offer.quoteOrderLine.trailerNumber == null || this.offer.quoteOrderLine.trailerNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Trailer # required.");
        }
        if (this.viewType != 'Unverified' && this.offer.quoteOrderLine.maxCarrierPay != null && this.getTotalCost() > this.offer.quoteOrderLine.maxCarrierPay && (this.offer.csManagerEmployeeID == 0 || this.offer.csManagerEmployeeID == null)) {
            this.isValid = false;
            this.validationWarningList.push("Manager approval required.");
        }
        if (!ppcCity.cityID) {
            this.isValid = false;
            this.validationWarningList.push("PPC City, ST required.");
        }
        if (this.ppcDate == null) {
            this.isValid = false;
            this.validationWarningList.push("PPC Date/Time required.");
        }
        if (this.viewType != 'orderentry' && this.getTotalCost() < 1) {
            this.isValid = false;
            this.validationWarningList.push("Total cost (Linehaul + Fuel + Acc.) must be greater than zero.");
        }
        if (!this.isValidExternalTrackingLink) {
            this.isValid = false;
            this.validationWarningList.push("Invalid External Tracking Link.");
        }
        if (!this.isLoadCarrierServiceComplete()) {
            this.isValid = false;
            this.validationWarningList.push("Load required services incomplete. Manager override required.");
        }
        //console.log("validate:pickupHours <= 6", this.getPickupHours() <= 6, this.getPickupHours());
        if (this.viewType != "orderentry" && this.offer.awarded != true && this.isPickupHoursConfirmed != true && this.getPickupHours() <= 6) {
            if (!confirm("This load is set to be picked up within 6 hours. Don't book this load without talking to the driver first! Have you talked to the driver?")) {
                this.isValid = false;
                this.isPickupHoursConfirmed = false;
                this.validationWarningList.push("Load pick up within 6 hours. Talk to driver first.");
            }
            else {
                this.isPickupHoursConfirmed = true;
            }
        }
        //console.log("validate:transitHours <= 24 || miles < 600", this.getTransitHours() <= 24 || this.offer.quoteOrderLine.miles <= 600, this.getTransitHours(), this.offer.quoteOrderLine.miles);
        if (this.viewType != "orderentry" && this.offer.awarded != true && this.isTransitHoursConfirmed != true && (this.getTransitHours() <= 24 || this.offer.quoteOrderLine.miles <= 600)) {
            if (!confirm("If this order is delivering direct, have you verified with the driver that they have the hours of service to deliver direct?")) {
                this.isValid = false;
                this.isTransitHoursConfirmed = false;
                this.validationWarningList.push("Transit within 24 hours or 600 miles. Verify with driver for deliver direct.");
            }
            else {
                this.isTransitHoursConfirmed = true;
            }
        }
    }

    private setOfferBatchQuoteOrderLines() {
        if (this.batchOffers.length > 0) {
            var isMissingCarrier: boolean = false;
            var line: QuoteOrderLine = Object.assign({}, this.offer.quoteOrderLine);
            for (var i = 0; i < this.batchOffers.length; i++) {
                var searchOffer = this.searchOfferList.find(t => t.offerID == this.batchOffers[i].offerID);
                this.batchOffers[i].quoteOrderLine.carrierContactId = line.carrierContactId;
                this.batchOffers[i].quoteOrderLine.driverId = line.driverId;
                this.batchOffers[i].quoteOrderLine.driver2Id = line.driver2Id;
                //this.batchOffers[i].quoteOrderLine.carrierID = line.carrierID;
                this.batchOffers[i].quoteOrderLine.carrierID = searchOffer!.carrierID;
                this.batchOffers[i].quoteOrderLine.truckNumber = line.truckNumber;
                this.batchOffers[i].quoteOrderLine.trailerNumber = line.trailerNumber;
                this.batchOffers[i].quoteOrderLine.cost = line.cost;
                this.batchOffers[i].quoteOrderLine.fuelCost = line.fuelCost;
                this.batchOffers[i].quoteOrderLine.accessorialCost = line.accessorialCost;
                this.batchOffers[i].quoteOrderLine.awardedCarrierRepId = line.awardedCarrierRepId;
                this.batchOffers[i].quoteOrderLine.loadVerified = line.loadVerified;

                if (this.batchOffers[i].quoteOrderLine.carrierID == null || this.batchOffers[i].quoteOrderLine.carrierID == 0) {
                    isMissingCarrier = true;
                }
            }
            //console.log("setOfferBatchQuoteOrderLines", line, this.searchOfferList, this.batchOffers);
            if (isMissingCarrier) {
                this.isValid = false;
                alert("There is an error in loading the carrier for this load. Cancelling the award process. Please attempt to award again or select the carrier on this load again.");
                this.cancelOffer();
            }
        }
        //console.log("setOfferBatchQuoteOrderLines", this.batchOffers);
    }

    public isValidUrl(url: string) {
        this.isValidExternalTrackingLink = this.utilService.isValidURL(url);
        this.validate(false);
    }

    public saveUnverifiedOffer(isMacropoint: boolean, isEmail: boolean) {
        this.recordLockAction = "saveUnverifiedOffer";
        this.isMacropoint = isMacropoint;
        this.isEmail = isEmail;
        this.utilService.isLoading = true;
        this.checkHasRecordLock();
    }

    private allowSaveUnverifiedOffer(isMacropoint: boolean, isEmail: boolean) {
        this.isSaving = true;
        this.validate(isMacropoint);

        var idList: number[] = [];
        var quoteOrderLineList: QuoteOrderLine[] = [];
        this.offerList.length = 0;
        this.offerList.push(this.offer);
        idList.push(this.offer.quoteOrderLineID);
        quoteOrderLineList.push(this.offer.quoteOrderLine);

        console.log("saveUnverifiedOffer", this.offerList, quoteOrderLineList, idList);

        this.isSaving = false;

        if (this.isValid) {
            this.utilService.setAuditNotes("Procurement: Save Unverified Offer");
            this.isSaving = true;
            this.saveStatusOffer = 1;
            this.cseService.saveAwardOfferFromCarrierSelection(this.offerList).subscribe(resultOffer => {
                console.log("saveOffer", resultOffer);

                if (resultOffer.message != "OK") {
                    this.saveStatusOffer = 2;
                    this.notificationService.showError("Error saving offer/order info:" + resultOffer.message, "ERROR: Save Offer/Order");
                }
                else {
                    this.saveStatusOffer = 3;
                    this.saveStatusAwardCarrier = 1;

                    this.cseService.saveAwardCarrierFromCarrierSelection(quoteOrderLineList).subscribe(resultAwardCarrier => {
                        console.log("saveAwardCarrierFromCarrierSelection", resultAwardCarrier);

                        if (resultAwardCarrier.message != "OK") {
                            this.saveStatusAwardCarrier = 2;
                            this.notificationService.showError("Error awarding carrier:" + resultAwardCarrier.message, "ERROR: Award Carrier");
                        }
                        else {
                            this.saveStatusAwardCarrier = 3;

                            //this.saveStatusTMW = 1;
                            //this.tmwService.saveTMWAdvancedCarrierSelection(quoteOrderLineList).subscribe(resultTMW => {
                            //    console.log("saveTMWAdvancedCarrierSelection", resultTMW);

                            //    if (resultTMW.message != "OK") {
                            //        this.saveStatusTMW = 2;
                            //        this.notificationService.showError("Error updating TMW order:" + resultTMW.message, "ERROR: Update TMW Order");
                            //    }
                            //    else {
                            //        this.saveStatusTMW = 3;
                            //        if (!isEmail) {
                            //            this.isSaving = false;
                            //            this.finishSave();
                            //        }
                            //    }
                            //});

                            //this.saveStatusPayDetail = 1;
                            //this.orderService.savePayDetailFromAwardOfferCarrierSelection(quoteOrderLineList).subscribe(resultPayDetail => {
                            //    console.log("savePayDetailFromAwardOfferCarrierSelection", resultPayDetail);

                            //    if (resultPayDetail.message != "OK") {
                            //        this.saveStatusPayDetail = 2;
                            //        this.notificationService.showError("Error updating pay details:" + resultPayDetail.message, "ERROR: Update Pay Details");
                            //    }
                            //    else {
                            //        this.saveStatusPayDetail = 3;
                            //        if (!isEmail) {
                            //            this.isSaving = false;
                            //            this.finishSave();
                            //        }
                            //    }
                            //});

                            //this.saveStatusTMWMove = 1;
                            //this.tmwService.updateTMWMove(quoteOrderLineList).subscribe(resultTMWMove => {
                            //    console.log("updateTMWMove", resultTMWMove);

                            //    if (resultTMWMove.message != "OK") {
                            //        this.saveStatusTMWMove = 2;
                            //        this.notificationService.showError("Error updating TMW move/sequence:" + resultTMWMove.message, "ERROR: Update TMW Move/Sequence");
                            //    }
                            //    else {
                            //        this.saveStatusTMWMove = 3;
                            //        if (!isMacropoint) {
                            //            if (!isEmail) {
                            //                this.isSaving = false;
                            //                this.finishSave();
                            //            }
                            //        }
                            //    }
                            //});

                            if (isMacropoint) {
                                this.saveStatusMacropoint = 1;
                                this.saveMacropoint().subscribe(resultMacropoint => {
                                    console.log("saveMacropoint", resultMacropoint);

                                    if (resultMacropoint.message != "OK") {
                                        this.saveStatusMacropoint = 2;
                                        this.notificationService.showError("Error saving Macropoint:" + resultMacropoint.message, "ERROR: Save Macropoint");
                                    }
                                    else if (resultMacropoint.validationCollection.length > 0) {
                                        this.saveStatusMacropoint = 2;
                                        this.notificationService.showError("Error saving Macropoint:" + resultMacropoint.validationCollection[0], "ERROR: Save Macropoint");
                                    }
                                    else {
                                        this.saveStatusMacropoint = 3;
                                        if (!isEmail) {
                                            this.isSaving = false;
                                            this.finishSave();
                                        }
                                    }
                                });
                            }
                            else if (!isEmail) {
                                this.finishSave();
                            }

                            if (isEmail) {
                                this.sendEmail();
                            }
                        }
                    });
                }
            });
        }
    }

    public saveBookedOffer(isMacropoint: boolean, isEmail: boolean) {
        this.recordLockAction = "saveBookedOffer";
        this.isMacropoint = isMacropoint;
        this.isEmail = isEmail;
        this.utilService.isLoading = true;
        this.checkHasRecordLock();
    }

    private allowSaveBookedOffer(isMacropoint: boolean, isEmail: boolean) {
        this.isSaving = true;
        this.validate(isMacropoint);

        var idList: number[] = [];
        var quoteOrderLineList: QuoteOrderLine[] = [];
        this.offerList.length = 0;
        this.offerList.push(this.offer);
        idList.push(this.offer.quoteOrderLineID);
        quoteOrderLineList.push(this.offer.quoteOrderLine);

        console.log("saveBookedOffer", this.offerList, quoteOrderLineList, idList);

        this.isSaving = false;

        if (this.isValid) {
            this.utilService.setAuditNotes("Procurement: Save Booked Offer");
            this.isSaving = true;
            this.saveStatusOffer = 1;
            this.cseService.saveAwardOfferFromCarrierSelection(this.offerList).subscribe(resultOffer => {
                console.log("saveOffer", resultOffer);

                if (resultOffer.message != "OK") {
                    this.saveStatusOffer = 2;
                    this.notificationService.showError("Error saving offer/order info:" + resultOffer.message, "ERROR: Save Offer/Order");
                }
                else {
                    this.saveStatusOffer = 3;
                    this.saveStatusAwardCarrier = 1;

                    this.cseService.saveAwardCarrierFromCarrierSelection(quoteOrderLineList).subscribe(resultAwardCarrier => {
                        console.log("saveAwardCarrierFromCarrierSelection", resultAwardCarrier);

                        if (resultAwardCarrier.message != "OK") {
                            this.saveStatusAwardCarrier = 2;
                            this.notificationService.showError("Error awarding carrier:" + resultAwardCarrier.message, "ERROR: Award Carrier");
                        }
                        else {
                            this.saveStatusAwardCarrier = 3;

                            this.saveStatusPayDetail = 1;
                            this.payDetailOffer = {
                                accessorialCostNotes: this.accessorialCostNotes,
                                lineList: quoteOrderLineList
                            }
                            this.orderService.savePayDetailFromAwardOfferCarrierSelection(this.payDetailOffer).subscribe(resultPayDetail => {
                                console.log("savePayDetailFromAwardOfferCarrierSelection", resultPayDetail);

                                if (resultPayDetail.message != "OK") {
                                    this.saveStatusPayDetail = 2;
                                    this.notificationService.showError("Error updating pay details:" + resultPayDetail.message, "ERROR: Update Pay Details");
                                }
                                else {
                                    this.saveStatusPayDetail = 3;
                                    if (!isEmail && !this.isAutoComplete) {
                                        this.isSaving = false;
                                        this.finishSave();
                                    }
                                    if (isEmail) {
                                        this.sendEmail();
                                    }
                                }
                            });

                            if (isMacropoint) {
                                this.saveStatusMacropoint = 1;
                                this.saveMacropoint().subscribe(resultMacropoint => {
                                    console.log("saveMacropoint", resultMacropoint);

                                    if (resultMacropoint.message != "OK") {
                                        this.saveStatusMacropoint = 2;
                                        this.notificationService.showError("Error saving Macropoint:" + resultMacropoint.message, "ERROR: Save Macropoint");
                                    }
                                    else if (resultMacropoint.validationCollection.length > 0) {
                                        this.saveStatusMacropoint = 2;
                                        this.notificationService.showError("Error saving Macropoint:" + resultMacropoint.validationCollection[0], "ERROR: Save Macropoint");
                                    }
                                    else {
                                        this.saveStatusMacropoint = 3;
                                        if (!isEmail) {
                                            this.isSaving = false;
                                            this.finishSave();
                                        }
                                    }
                                });
                            }
                            else if (!isEmail) {
                                this.finishSave();
                            }
                        }
                    });
                }
            });
        }
    }

    public saveOffer(isMacropoint: boolean, isEmail: boolean) {
        this.recordLockAction = "saveOffer";
        this.isMacropoint = isMacropoint;
        this.isEmail = isEmail;
        this.utilService.isLoading = true;
        this.checkHasRecordLock();
        this.isSaving = true;
        console.log("saveOffer");
    }

    private allowSaveOffer(isMacropoint: boolean, isEmail: boolean) {
        this.utilService.isLoading = true;
        this.isSaving = true;
        var isAwarded: boolean = false;
        this.validate(isMacropoint);

        //if (this.offer.awarded == true) {
        //    this.notificationService.showInfo("Not yet implemented.", "INFO: Save Offer/Order");
        //    return;
        //}

        var idList: number[] = [];
        var quoteOrderLineList: QuoteOrderLine[] = [];
        if (this.batchOffers.length > 0) {
            this.offerList = Object.assign([], this.batchOffers);
            for (var i = 0; i < this.batchOffers.length; i++) {
                idList.push(this.batchOffers[i].quoteOrderLineID);
                quoteOrderLineList.push(this.batchOffers[i].quoteOrderLine);
            }
            this.setOfferBatchQuoteOrderLines();
        }
        else {
            this.offerList.length = 0;
            this.offerList.push(this.offer);
            idList.push(this.offer.quoteOrderLineID);
            quoteOrderLineList.push(this.offer.quoteOrderLine);
        }

        this.checkAwarded().subscribe(result => {
            if (this.viewType == "Orders") {
                var offerCheckList: Offer[] = result.resultCollection;
                for (var i = 0; i < offerCheckList.length; i++) {
                    if (offerCheckList[i].awarded == true) {
                        isAwarded = true;
                    }
                }

                if (isAwarded && this.viewType == "Orders") {
                    if (this.batchOffers.length > 0) {
                        this.notificationService.showError("Offer(s) in batch already awarded and would cause double-booking.", "WARNING: Offer(s) Awarded");
                    }
                    else {
                        this.notificationService.showError("Offer already awarded and would cause double-booking.", "WARNING: Offer Awarded");
                    }
                }
            }

            console.log("saveOffer", isAwarded, this.offerID, this.offerBatchID, this.offerList, quoteOrderLineList, idList);

            this.utilService.isLoading = false;

            if (this.isValid && !isAwarded) {
                this.utilService.setAuditNotes("Procurement: Save Award Offer");
                this.isSaving = true;
                this.saveStatusOffer = 1;
                this.cseService.saveAwardOfferFromCarrierSelection(this.offerList).subscribe(resultOffer => {
                    console.log("saveOffer", resultOffer);

                    if (resultOffer.message != "OK") {
                        this.saveStatusOffer = 2;
                        this.notificationService.showError("Error saving offer/order info:" + resultOffer.message, "ERROR: Save Offer/Order");
                    }
                    else {
                        this.saveStatusOffer = 3;
                        this.saveStatusDeleteSched = 1;

                        this.deleteOrderEventSchedule().subscribe(resultDeleteSchedule => {
                            console.log("deleteOrderEventSchedule", resultDeleteSchedule);

                            if (resultDeleteSchedule.message != "OK") {
                                this.saveStatusDeleteSched = 2;
                                this.notificationService.showError("Error deleting current schedule:" + resultDeleteSchedule.message, "ERROR: Delete Schedule");
                            }
                            else {
                                this.saveStatusDeleteSched = 3;
                                this.saveStatusSetSched = 1;

                                this.setOrderEventSchedule().subscribe(resultSetSchedule => {
                                    console.log("setOrderEventSchedule", resultSetSchedule);

                                    if (resultSetSchedule.message != "OK") {
                                        this.saveStatusSetSched = 2;
                                        this.notificationService.showError("Error setting schedule:" + resultSetSchedule.message, "ERROR: Set Schedule");
                                    }
                                    else {
                                        this.saveStatusSetSched = 3;
                                        this.saveStatusPPC = 1;

                                        this.addPrePickupSave().subscribe(resultPPC => {
                                            console.log("addPrePickupSave", resultPPC);

                                            if (resultPPC.message != "OK") {
                                                this.saveStatusPPC = 2;
                                                this.notificationService.showError("Error saving pre-pickup:" + resultPPC.message, "ERROR: Save Pre-Pickup");
                                            }
                                            else {
                                                this.saveStatusPPC = 3;
                                                this.saveStatusSched = 1;

                                                this.saveOrderEventScheduleFromCarrierSelection(quoteOrderLineList).subscribe(resultSched => {
                                                    console.log("saveOrderEventScheduleFromCarrierSelection", resultSched);

                                                    if (resultSched.message != "OK") {
                                                        this.saveStatusSched = 2;
                                                        this.notificationService.showError("Error saving tracking schedule:" + resultSched.message, "ERROR: Save Tracking Schedule");
                                                    }
                                                    else {
                                                        this.saveStatusSched = 3;
                                                        this.saveStatusAwardCarrier = 1;

                                                        this.cseService.saveAwardCarrierFromCarrierSelection(quoteOrderLineList).subscribe(resultAwardCarrier => {
                                                            console.log("saveAwardCarrierFromCarrierSelection", resultAwardCarrier);

                                                            if (resultAwardCarrier.message != "OK") {
                                                                this.saveStatusAwardCarrier = 2;
                                                                this.notificationService.showError("Error awarding carrier:" + resultAwardCarrier.message, "ERROR: Award Carrier");
                                                            }
                                                            else {
                                                                this.saveStatusAwardCarrier = 3;

                                                                //if (!this.isExportHub && this.searchQuoteOrderLine.externalOrderNumber != null && this.searchQuoteOrderLine.externalOrderNumber != "") {
                                                                //    this.saveStatusTMW = 1;
                                                                //    this.tmwService.saveTMWAdvancedCarrierSelection(quoteOrderLineList).subscribe(resultTMW => {
                                                                //        console.log("saveTMWAdvancedCarrierSelection", resultTMW);

                                                                //        if (resultTMW.message != "OK") {
                                                                //            this.saveStatusTMW = 2;
                                                                //            this.notificationService.showError("Error updating TMW order:" + resultTMW.message, "ERROR: Update TMW Order");
                                                                //        }
                                                                //        else {
                                                                //            this.saveStatusTMW = 3;
                                                                //            if (!isEmail && !this.isAutoComplete) {
                                                                //                this.isSaving = false;
                                                                //                this.finishSave();
                                                                //            }
                                                                //        }
                                                                //    });
                                                                //}

                                                                this.saveStatusPayDetail = 1;
                                                                this.payDetailOffer = {
                                                                    accessorialCostNotes: this.accessorialCostNotes,
                                                                    lineList: quoteOrderLineList
                                                                }
                                                                this.orderService.savePayDetailFromAwardOfferCarrierSelection(this.payDetailOffer).subscribe(resultPayDetail => {
                                                                    console.log("savePayDetailFromAwardOfferCarrierSelection", resultPayDetail);

                                                                    if (resultPayDetail.message != "OK") {
                                                                        this.saveStatusPayDetail = 2;
                                                                        this.notificationService.showError("Error updating pay details:" + resultPayDetail.message, "ERROR: Update Pay Details");
                                                                    }
                                                                    else {
                                                                        this.saveStatusPayDetail = 3;
                                                                        if (!isEmail && !this.isAutoComplete) {
                                                                            this.isSaving = false;
                                                                            this.finishSave();
                                                                        }
                                                                        if (isEmail) {
                                                                            this.sendEmail();
                                                                        }
                                                                    }
                                                                });

                                                                //if (!this.isExportHub && this.searchQuoteOrderLine.externalOrderNumber != null && this.searchQuoteOrderLine.externalOrderNumber != "") {
                                                                //    this.saveStatusTMWMove = 1;
                                                                //    this.tmwService.updateTMWMove(quoteOrderLineList).subscribe(resultTMWMove => {
                                                                //        console.log("updateTMWMove", resultTMWMove);

                                                                //        if (resultTMWMove.message != "OK") {
                                                                //            this.saveStatusTMWMove = 2;
                                                                //            this.notificationService.showError("Error updating TMW move/sequence:" + resultTMWMove.message, "ERROR: Update TMW Move/Sequence");
                                                                //        }
                                                                //        else {
                                                                //            this.saveStatusTMWMove = 3;
                                                                //            if (!isMacropoint) {
                                                                //                if (!isEmail && !this.isAutoComplete) {
                                                                //                    this.isSaving = false;
                                                                //                    this.finishSave();
                                                                //                }
                                                                //            }
                                                                //        }
                                                                //    });
                                                                //}

                                                                if (isMacropoint) {
                                                                    this.saveStatusMacropoint = 1;
                                                                    this.saveMacropoint().subscribe(resultMacropoint => {
                                                                        console.log("saveMacropoint", resultMacropoint);

                                                                        if (resultMacropoint.message != "OK") {
                                                                            this.saveStatusMacropoint = 2;
                                                                            this.notificationService.showError("Error saving Macropoint:" + resultMacropoint.message, "ERROR: Save Macropoint");
                                                                        }
                                                                        else {
                                                                            this.saveStatusMacropoint = 3;
                                                                            if (!isEmail && !this.isAutoComplete) {
                                                                                this.isSaving = false;
                                                                                this.finishSave();
                                                                            }
                                                                        }
                                                                    });
                                                                }

                                                                //if (this.isAutoComplete) {
                                                                //    this.saveStatusAutoComplete = 1;
                                                                //    this.orderService.saveAutoCompleteQuoteOrderLine(this.searchQuoteOrderLine.quoteOrderLineID, parseInt(localStorage.getItem('EmployeeId')!)).subscribe(resultAutoComplete => {
                                                                //        console.log("saveAutoComplete", resultAutoComplete);

                                                                //        if (resultAutoComplete.message != "OK") {
                                                                //            this.saveStatusAutoComplete = 2;
                                                                //            this.notificationService.showError("Error auto-completing order:" + resultAutoComplete.message, "ERROR: Auto-Complete Order");
                                                                //        }
                                                                //        else {
                                                                //            this.saveStatusAutoComplete = 3;
                                                                //            if (!isEmail) {
                                                                //                this.isSaving = false;
                                                                //                this.finishSave();
                                                                //            }
                                                                //        }
                                                                //    });
                                                                //}
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }


        // Save QuoteOrderLine is done in the saveAwardOfferFromCarrierSelection call
        //this.orderService.saveQuoteOrderLine(this.quoteOrderLine).subscribe(result => {
        //    this.quoteOrderLine = result;
        //});
        });
    }

    private finishSave() {
        this.clearRecordLock();
        this.onSaveClick.emit();
    }

    private checkAwarded(): Observable<APIResponse> {
        return this.cseService.getOffersByLineIdObs(this.offer.quoteOrderLineID);
    }

    private setOrderEventSchedule(): Observable<APIResponse> {
        //var city = this.offerForm.controls['ppcCityControl'].value as City;
        if (this.loadStatus != 'Dispatched' && this.loadStatus != 'Started' && !this.isPPCCompleted) {
            if (this.batchOffers.length > 0) {
                var idList: number[] = [];
                for (var i = 0; i < this.batchOffers.length; i++) {
                    idList.push(this.batchOffers[i].quoteOrderLineID);
                }
                return this.orderService.setOrderEventScheduleViewByQuoteOrderLineIdList(idList);
            }
            else {
                return this.orderService.setOrderEventScheduleViewByQuoteOrderLineId(this.offer.quoteOrderLineID);
            }
        }
        else {
            return of<APIResponse>({
                statusCode: 200,
                totalRecords: 0,
                message: "OK",
                resultCollection: [],
                errorCollection: [],
                validationCollection: []
            });
        }
    }

    private deleteOrderEventSchedule(): Observable<APIResponse> {
        //var city = this.offerForm.controls['ppcCityControl'].value as City;
        if (this.loadStatus != 'Dispatched' && this.loadStatus != 'Started' && !this.isPPCCompleted) {
            if (this.batchOffers.length > 0) {
                var idList: number[] = [];
                for (var i = 0; i < this.batchOffers.length; i++) {
                    idList.push(this.batchOffers[i].quoteOrderLineID);
                }
                return this.orderService.deleteOrderEventScheduleByQuoteOrderLineIdList(idList);
            }
            else {
                return this.orderService.deleteOrderEventScheduleByQuoteOrderLineId(this.offer.quoteOrderLineID);
            }
        }
        else {
            return of<APIResponse>({
                statusCode: 200,
                totalRecords: 0,
                message: "OK",
                resultCollection: [],
                errorCollection: [],
                validationCollection: []
            });
        }
    //    return of<APIResponse>({
    //        statusCode: 200,
    //        totalRecords: 0,
    //        message: "OK",
    //        resultCollection: [],
    //        errorCollection: [],
    //        validationCollection: []
    //    });
    }

    private addPrePickupSave(): Observable<APIResponse> {
        //var city = this.offerForm.controls['ppcCityControl'].value as City;
        if (this.loadStatus != 'Dispatched' && this.loadStatus != 'Started' && !this.isPPCCompleted) {
            var nonStopEventTypes = this.searchOrderEventTypes.filter(c => c.code == "PPC" && c.eventTypeName == "Non-Stop Order Event");
            //if (nonStopEventTypes.length > 0) {
            //}
            var eventType = this.orderEventTypes.filter(o => o.code == "PPC")[0];
            var ppcEventType = nonStopEventTypes[0];
            //var city = this.offerForm.controls['ppcCityControl'].value as City;
            //console.log("addPrePickupSave", this.carrierTenderFormGroup.controls['prePickupCityControl'].value, city);
            if (this.batchOffers.length > 0) {
                var schedList: OrderEventSchedule[] = [];
                for (var i = 0; i < this.batchOffers.length; i++) {
                    var sched: OrderEventSchedule = {} as OrderEventSchedule;
                    sched.orderEventScheduleID = -1;
                    sched.orderEventTypeID = ppcEventType.orderEventTypeID;
                    sched.orderStopID = 0;
                    sched.cityID = this.ppcCity.cityID;
                    sched.epiTimeZoneID = this.ppcCity.epiTimeZoneID;
                    sched.quoteOrderLineID = this.batchOffers[i].quoteOrderLineID;
                    sched.orderEventSequence = 0;

                    var stops: SearchOrderStop[] = this.batchOrderStops.filter(s => s.quoteOrderLineID == this.batchOffers[i].quoteOrderLineID);
                    stops = stops.sort((left, right): number => {
                        if (left.stopSequence < right.stopSequence) return -1;
                        if (left.stopSequence > right.stopSequence) return 1;
                        return 0;
                    });
                    var stop = stops.filter(s => s.eventCode == "HLT" || s.eventCode == "LLD");
                    var pickupStop = stop[0];
                    var ppcDate = new Date(pickupStop.earliestDate);
                    //ppcDate = this.utilService.getDateAsUTC(ppcDate);
                    if (this.isBatchPPCTimeSame == true) {
                        if (ppcDate.getHours() < 2) {
                            ppcDate = this.utilService.addDays(ppcDate, -1);
                        }
                        ppcDate.setHours(this.ppcDate.getHours());
                        ppcDate.setMinutes(this.ppcDate.getMinutes());
                        sched.orderEventDate = new Date(ppcDate);
                    }
                    else if (stop.length > 0) {
                        if (this.ppcHoursBefore > 0) {
                            //ppcDate.setTime(ppcDate.getTime() - this.ppcHoursBefore * 60 * 60 * 1000);
                            ppcDate = this.utilService.addHours(ppcDate, 0 - this.ppcHoursBefore);
                        }
                        else {
                            //ppcDate.setTime(ppcDate.getTime() - 2 * 60 * 60 * 1000);
                            ppcDate = this.utilService.addHours(ppcDate, 0 - 2);
                        }
                        sched.orderEventDate = ppcDate;
                    }

                    sched.orderEventType = eventType;
                    sched.completed = false;
                    sched.isRefreshNeeded = false;
                    sched.cancelled = false;
                    sched.notes = this.ppcNotes;
                    schedList.push(sched);
                    console.log("addPrePickupSave", this.isBatchPPCTimeSame, ppcDate, stop, sched);
                }
                for (var i = 0; i < schedList.length; i++) {
                    schedList[i].orderEventDate = this.utilService.getDateAsUTC(schedList[i].orderEventDate);
                    if (schedList[i].nextETADate != null) {
                        schedList[i].nextETADate = this.utilService.getDateAsUTC(schedList[i].nextETADate!);
                    }
                    if (schedList[i].completedDate != null) {
                        schedList[i].completedDate = this.utilService.getDateAsUTC(schedList[i].completedDate);
                    }
                }
                return this.orderService.saveOrderEventScheduleList(schedList as OrderEventSchedule[]);
            }
            else {
                var sched: OrderEventSchedule = {} as OrderEventSchedule;
                sched.orderEventScheduleID = -1;
                sched.orderEventTypeID = ppcEventType.orderEventTypeID;
                sched.orderStopID = 0;
                sched.cityID = this.ppcCity.cityID;
                sched.quoteOrderLineID = this.offer.quoteOrderLineID;
                sched.orderEventSequence = 0;
                sched.orderEventDate = this.ppcDate;
                sched.orderEventType = eventType;
                sched.completed = false;
                sched.isRefreshNeeded = false;
                sched.cancelled = false;
                sched.notes = this.ppcNotes;
                //this.utilService.isLoading = true;
                sched.orderEventDate = this.utilService.getDateAsUTC(sched.orderEventDate);
                if (sched.nextETADate != null) {
                    sched.nextETADate = this.utilService.getDateAsUTC(sched.nextETADate);
                }
                if (sched.completedDate != null) {
                    sched.completedDate = this.utilService.getDateAsUTC(sched.completedDate);
                }

                var isUpdateFuture = false;
                //if (this.ppcTravelText != "") {
                //    isUpdateFuture = true;
                //}
                return this.orderService.saveOrderEventSchedule(sched as OrderEventSchedule, isUpdateFuture);
                //this.orderService.saveOrderEventSchedule(sched as OrderEventSchedule, false).subscribe(result => {
                //    this.utilService.isLoading = false;
                //    var ok = result;
                //    this.utilService.isLoading = true;
                //    this.orderService.setOrderEventScheduleViewByQuoteOrderLineId(sched.quoteOrderLineId).subscribe(result => {
                //        this.utilService.isLoading = false;
                //        var ok = result;
                //        this.finishSave();
                //    });
                //});
            }
        }
        else {
            return of<APIResponse>({
                statusCode: 200,
                totalRecords: 0,
                message: "OK",
                resultCollection: [],
                errorCollection: [],
                validationCollection: []
            });
        }
    }

    private saveOrderEventScheduleFromCarrierSelection(quoteOrderLineList: QuoteOrderLine[]): Observable<APIResponse> {
        //var city = this.offerForm.controls['ppcCityControl'].value as City;
        if (this.loadStatus != 'Dispatched' && this.loadStatus != 'Started' && !this.isPPCCompleted) {
            return this.orderService.saveOrderEventScheduleFromCarrierSelection(quoteOrderLineList);
        }
        else {
            return of<APIResponse>({
                statusCode: 200,
                totalRecords: 0,
                message: "OK",
                resultCollection: [],
                errorCollection: [],
                validationCollection: []
            });
        }
    }

    public cancelOffer() {
        if (this.offerBatchID > 0) {
            this.utilService.isLoading = true;
            this.cseService.deleteOfferBatch(this.offerBatchID).subscribe(result => {
                this.utilService.isLoading = false;
                this.notificationService.showSuccess("Bulk Tender canceled.", "CANCELED: Bulk Tender");
                this.cancelEdit();
            });
        }
        else {
            this.cancelEdit();
        }
    }

    public cancelEdit() {
        console.log("carrier-offer-form:cancelEdit", this.recordLockAction);
        this.clearRecordLock();
        this.onCancelClick.emit();
    }

    private getMacropointCell(cell: string, countryAbbrev: string) {
        if (cell != null && cell != "" && countryAbbrev != null && countryAbbrev.trim() != "" && countryAbbrev.trim() != "US" && countryAbbrev.trim() != "CA") {
            return "+" + cell;
        }
        else {
            return cell;
        }
    }

    public saveMacropoint() {
        var macroList: MacropointData[] = [];
        var trackingNumber: string = "";
        var trackingNumberTwo: string = "";

        if (this.batchOffers.length > 0) {
            for (var i = 0; i < this.batchOffers.length; i++) {
                switch (this.macropointLocationProviderDevice) {
                    case "Mobile":
                        trackingNumber = this.getMacropointCell(this.selectedDriver.cell, this.selectedDriver.cellCountryAbbrev);
                        trackingNumberTwo = this.getMacropointCell(this.selectedDriver2.cell, this.selectedDriver2.cellCountryAbbrev);
                        break;
                    case "VehicleID":
                        trackingNumber = this.offer.quoteOrderLine.truckNumber;
                        break;
                    case "TrailerID":
                        trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                        break;
                    case "Macropoint":
                        trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                        break;
                    default:
                        trackingNumber = this.getMacropointCell(this.selectedDriver.cell, this.selectedDriver.cellCountryAbbrev);
                        if (trackingNumber == "") trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                        break;
                }

                var macroData = {
                    quoteOrderLineId: this.offer.quoteOrderLineID,
                    trackingNumber: trackingNumber,
                    trackingNumberTwo: trackingNumberTwo,
                    emails: this.macropointEmails,
                    beginTracking: this.beginTrackingDate,
                    endTracking: this.endTrackingDate,
                    //hoursToTrack: 0,
                    trackInterval: this.macropointTrackInterval,
                    //notes = "Order #" + this.offer.quoteOrderLine.orderNumber + " - " + this.offer.quoteOrderLine.oCity.cityStateZip + " to " + this.offer.quoteOrderLine.dCity.cityStateZip;
                    employeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    locationProvider: this.macropointLocationProviders.find(t => t.macropointLocationProviderId == this.macropointLocationProviderId)!
                    //returnMessage = "";
                } as MacropointData;
                macroList.push(macroData);
            }
        }
        else {
            switch (this.macropointLocationProviderDevice) {
                case "Mobile":
                    trackingNumber = this.getMacropointCell(this.selectedDriver.cell, this.selectedDriver.cellCountryAbbrev);
                    trackingNumberTwo = this.getMacropointCell(this.selectedDriver2.cell, this.selectedDriver2.cellCountryAbbrev);
                    break;
                case "VehicleID":
                    trackingNumber = this.offer.quoteOrderLine.truckNumber;
                    break;
                case "TrailerID":
                    trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                    break;
                case "Macropoint":
                    trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                    break;
                default:
                    trackingNumber = this.offer.quoteOrderLine.trailerNumber;
                    if (trackingNumber == "") trackingNumber = this.getMacropointCell(this.selectedDriver.cell, this.selectedDriver.cellCountryAbbrev);
                    break;
            }

            this.macropointData.quoteOrderLineId = this.offer.quoteOrderLineID;
            this.macropointData.trackingNumber = trackingNumber;
            this.macropointData.trackingNumberTwo = trackingNumberTwo;
            this.macropointData.emails = this.macropointEmails;
            this.macropointData.beginTracking = this.beginTrackingDate;
            this.macropointData.endTracking = this.endTrackingDate;
            //this.macropointData.hoursToTrack = 0;
            this.macropointData.trackInterval = this.macropointTrackInterval;
            //this.macropointData.notes = "Order #" + this.offer.quoteOrderLine.orderNumber + " - " + this.offer.quoteOrderLine.oCity.cityStateZip + " to " + this.offer.quoteOrderLine.dCity.cityStateZip;
            this.macropointData.employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.macropointData.locationProvider = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == this.macropointLocationProviderId)!;
            //this.macropointData.returnMessage = "";
            macroList.push(this.macropointData);
        }

        return this.erpService.saveMacropointDataList(macroList);
    }

    public sendEmail() {
        var contacts: Email[] = [];
        var selectedContacts: Email[] = [];
        var typedEmails: string = "";
        var defaultContact: Email | undefined;

        for (var i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].email != null && this.contacts[i].email != "") {
                contacts.push({
                    email: this.contacts[i].email,
                    name: this.contacts[i].contactName
                });
            }
        }

        if (this.offer.quoteOrderLine.carrierContactId) {
            var contact = this.contacts.find(c => c.contactID == this.offer.quoteOrderLine.carrierContactId && c.email != null && c.email != "");
            defaultContact = {
                email: contact!.email,
                name: contact!.contactName
            }
        }

        typedEmails = "tracking@automatedlogistics.com";

        var fromEmail = localStorage.getItem('EpiEmail')!;
        if (fromEmail != null && fromEmail != "") {
            typedEmails = typedEmails + "," + fromEmail;
        }

        if (this.selectedCarrierRep && this.selectedCarrierRep.email != null) {
            typedEmails = typedEmails + "," + this.selectedCarrierRep.email;
        }

        //console.log("dialog.open", contacts, defaultContact, selectedContacts, typedEmails);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showNotes: true,
            contacts: contacts,
            defaultContact: defaultContact,
            selectedContacts: selectedContacts,
            typedEmails: typedEmails
        }

        const dialogRef = this.dialog.open(ContactMultiselectDialog, dialogConfig);

        //dialogRef.componentInstance.notes = dataItem.comment;

        dialogRef.afterClosed().subscribe(result => {
            if (result.btnOK == true) {
                //console.log("sendEmail:dialogRef.afterClosed()", result);
                if (defaultContact == undefined) {
                    if (selectedContacts.length > 0) {
                        defaultContact = selectedContacts[0];
                    }
                    else {
                        defaultContact = {
                            email: "",
                            name: ""
                        }
                    }
                }

                if (result == null ||
                    (
                        (defaultContact.email == null || defaultContact.email == "")
                        && (result.selectedContacts == null || result.selectedContacts.length < 1)
                        && (result.selectedEmails == null || result.selectedEmails.length < 1)
                    )
                ) return;

                var ccEmails = "";
                if (result.selectedContacts != null) {
                    result.selectedContacts.forEach(e => {
                        ccEmails += e.email + "|";
                    });
                }
                if (result.typedEmails && result.typedEmails.indexOf(",") >= 0) {
                    var typedEmails = result.typedEmails.split(",");
                    typedEmails.forEach(e => {
                        var email = e.trim();
                        if (ccEmails.indexOf(email) < 0) {
                            ccEmails += email + "|";
                        }
                    });
                }
                else {
                    ccEmails += result.typedEmails;
                }

                this.utilService.isLoading = true;
                if (this.batchOffers.length > 0) {
                    //var subject = "Load Tender (" + this.batchOffers.length + " loads) " + this.offer.quoteOrderLine.oCity.cityStateZip + " to " + this.offer.quoteOrderLine.dCity.cityStateZip;
                    var subject = "Load Tender (" + this.batchOffers.length + " loads) " + this.searchQuoteOrderLine.originCityStateZip + " to " + this.searchQuoteOrderLine.destinationCityStateZip;
                    this.emailService.sendRateConfirmationBatch(this.offerBatchID, defaultContact.email, ccEmails, "", -1, subject, result.notes).subscribe(emailResult => {
                        this.utilService.isLoading = false;
                        var ok = emailResult;
                        this.isSaving = false;
                        this.finishSave();
                    });
                }
                else {
                    //var subject = "Carrier award offer for order #" + this.searchQuoteOrderLine.orderNumber + " - " + this.offer.quoteOrderLine.oCity.cityStateZip + " to " + this.offer.quoteOrderLine.dCity.cityStateZip;
                    var subject = "Carrier award offer for order #" + this.searchQuoteOrderLine.orderNumber + " - " + this.searchQuoteOrderLine.originCityStateZip + " to " + this.searchQuoteOrderLine.destinationCityStateZip;
                    this.emailService.sendRateConfirmationCustom(this.offer.quoteOrderLineID, defaultContact.email, ccEmails, "", -1, subject, result.notes).subscribe(emailResult => {
                        this.utilService.isLoading = false;
                        var ok = emailResult;
                        this.isSaving = false;
                        this.finishSave();
                    });
                }
            //this.emailService.sendEmail(defaultContact.email, emails, "", -1, subject, result.notes).subscribe(emailResult => {
            //    this.utilService.isLoading = false;
            //    var ok = emailResult;
            //    this.isSaving = false;
            //    this.finishSave();
            //});
            }
        });
    }

    private clearRecordLock() {
        this.recordLockAction = "";
        if (this.offerBatchID > 0) {
            var idList: number[] = [];
            for (var i = 0; i < this.batchOffers.length; i++) {
                idList.push(this.batchOffers[i].quoteOrderLine.quoteOrderID);
            }
            //console.log("carrier-offer-form:clearRecordLockList", idList);
            this.recordLockService.clearRecordLockList("QuoteOrder", idList, this.recordLockSource);
            this.recordLockService.resetRecordLock();
        }
        else {
            var recordID = this.searchQuoteOrderLine.quoteOrderID;
            //console.log("carrier-offer-form:clearRecordLock", recordID);
            this.recordLockService.clearRecordLock("QuoteOrder", recordID, this.recordLockSource);
            this.recordLockService.resetRecordLock();
        }
        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
    }

    private initRecordLock() {
        this.recordLockService.resetRecordLock();
        this.recordLockAction = "";
        this.recordLockSource = "Procurement";
        if (this.pageType == "orderentry") {
            this.recordLockSource = "Order Entry";
        }
        else if (this.pageType == "procurement") {
            this.recordLockSource = "Procurement";
        }
        //this.recordLockService.continueRecordLockObserver.observers.length = 1;
        //this.recordLockService.cancelOverrideObserver.observers.length = 1;
        //this.recordLockService.timeoutRecordLockObserver.observers.length = 1;
        //this.recordLockService.timeoutConfirmObserver.observers.length = 1;
        //this.recordLockService.hasRecordLockObserver.observers.length = 1;
        //if (this.recordLockService.continueRecordLockObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.cancelOverrideObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.timeoutRecordLockObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.timeoutConfirmObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.hasRecordLockObserver.observers.length < 2) {
        //}
        this.recordLockService.continueRecordLockObserver.subscribe(result => {
            //console.log("carrier-offer-form:initRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.isContinueRecordLock) {
                //this.continueRecordLockAction();
            }
        });
        this.recordLockService.cancelOverrideObserver.subscribe(result => {
            //console.log("carrier-offer-form:initRecordLock:isCancelOverride", this.recordLockService.isCancelOverride);
            if (this.recordLockService.isCancelOverride) {
                this.cancelEdit();
            }
        });
        this.recordLockService.timeoutRecordLockObserver.subscribe(result => {
            //console.log("carrier-offer-form:initRecordLock:isRecordLockTimeout", this.recordLockService.isRecordLockTimeout, this.recordLockAction, this.recordLockService.searchRecordLock);
            if (this.recordLockService.isRecordLockTimeout) {
                this.clearRecordLock();
                //this.continueRecordLockAction();
            }
        });
        this.recordLockService.timeoutConfirmObserver.subscribe(result => {
            //console.log("carrier-offer-form:initRecordLock:timeoutConfirmObserver", this.recordLockService.isConfirmTimeout, this.recordLockAction, this.recordLockService.searchRecordLock);
            if (this.recordLockService.isConfirmTimeout) {
                this.recordLockService.resetRecordLock();
                //this.navigateQuoteOrder(this.quoteOrderID, true);
                this.cancelEdit();
            }
        });
        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            //console.log("carrier-offer-form:initRecordLock:hasRecordLock", this.recordLockService.hasRecordLock);
            this.utilService.isLoading = false;
            this.isSaving = false;
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "saveOffer") {
                    this.allowSaveOffer(this.isMacropoint, this.isEmail);
                }
                else if (this.recordLockAction == "saveBookedOffer") {
                    this.allowSaveBookedOffer(this.isMacropoint, this.isEmail);
                }
                else if (this.recordLockAction == "saveUnverifiedOffer") {
                    this.allowSaveUnverifiedOffer(this.isMacropoint, this.isEmail);
                }
                this.recordLockAction = "";
            }
        });
    }

    private handleRecordLock(id: number) {
        //console.log("order-form:handleRecordLock", id);
        if (this.recordLockSource == "Procurement") {
            if (this.offerBatchID > 0) {
                var idList: number[] = [];
                for (var i = 0; i < this.batchOffers.length; i++) {
                    idList.push(this.batchOffers[i].quoteOrderLine.quoteOrderID);
                }
                //this.recordLockService.handleRecordLockList("QuoteOrder", idList, this.recordLockSource);
            }
            else {
                this.recordLockService.handleRecordLock("QuoteOrder", id, this.recordLockSource);
            }
        }
    }

    private checkHasRecordLock() {
        if (this.offerBatchID > 0) {
            var idList: number[] = [];
            for (var i = 0; i < this.batchOffers.length; i++) {
                idList.push(this.batchOffers[i].quoteOrderLine.quoteOrderID);
            }
            this.recordLockService.checkHasRecordLockList("QuoteOrder", idList, this.recordLockSource);
        }
        else {
            this.recordLockService.checkHasRecordLock("QuoteOrder", this.searchQuoteOrderLine.quoteOrderID, this.recordLockSource);
        }
    }
}
